// Utilities to determine tenant from current hostname

/**
 * getTenantFromHost determines the tenant based on the hostname.
 * Rules:
 * - Only apply parsing for *.ziplink.se; otherwise default to "handla".
 * - ziplink.se or no subdomain -> "handla".
 * - dev.<tenant>.ziplink.se -> <tenant> (e.g., dev.handla -> handla)
 * - www.<tenant>.ziplink.se -> <tenant>
 * - admin.* -> "handla" (ignored)
 * - otherwise -> first label (e.g., boxmart.ziplink.se -> boxmart)
 *
 * @param {string|undefined} hostOverride Optional host for testing or SSR.
 * @returns {string} tenant key
 */
export function getTenantFromHost(hostOverride) {
  // Resolve host without mixing ?? and || in one expression (ESLint rule)
  const resolvedHost = hostOverride != null
    ? hostOverride
    : (typeof window !== "undefined" ? window.location.hostname : "");
  const host = (resolvedHost || "").toLowerCase();

  if (!host.endsWith(".ziplink.se")) {
    return "handla";
  }

  const labels = host.split(".").slice(0, -2); // drop "ziplink.se"

  if (labels.length === 0) {
    return "handla";
  }

  // dev.handla.ziplink.se → handla
  if (labels[0] === "dev" && labels[1]) {
    return labels[1];
  }

  // www.boxmart.ziplink.se → boxmart
  if (labels[0] === "www" && labels[1]) {
    return labels[1];
  }

  // ignore admin project hosts if they ever hit this bundle
  if (labels[0] === "admin") {
    return "handla";
  }

  return labels[0]; // boxmart.ziplink.se → boxmart
}

export default getTenantFromHost;
